// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1synQ","tabs":"styles_tabs__zsPcL","tab":"styles_tab__1JLH6","tab-active":"styles_tab-active__2WTE8"};